module.exports = __webpack_public_path__ + "static/placeholder-95e73ba1ebbfc939687c0b9293419721.png";